import { Card, CardContent } from '@/ui/base/card';
import { Progress } from '@/ui/base/progress';
import { formatarDinheiro } from '@/nucleo/dinheiro';
import { GlossaryTerm } from '@/ui/GlossaryTerm';

import type { CicloConsolidado } from './tipos';

/** Barra de progresso: percentual do valor distribuído já encaminhado ao SOF. */
export function PipelineDePagamento({
  dados,
}: {
  dados: Pick<CicloConsolidado, 'valorEmLotes' | 'valorDistribuido'>;
}) {
  const pct = dados.valorDistribuido > 0 ? (dados.valorEmLotes / dados.valorDistribuido) * 100 : 0;

  return (
    <Card className="rounded-2xl">
      <CardContent className="space-y-4 pt-6">
        <div>
          <div className="mb-2 flex justify-between text-sm">
            <span className="font-medium">
              <GlossaryTerm termo="PIPELINE_PAGAMENTO" esconderIcone>
                Pipeline de pagamento
              </GlossaryTerm>
            </span>
            <span className="tabular-nums text-muted-foreground">
              {formatarDinheiro(dados.valorEmLotes)} / {formatarDinheiro(dados.valorDistribuido)}
            </span>
          </div>
          <Progress value={pct} aria-label="Percentual do valor distribuído encaminhado ao SOF" />
          <p className="mt-2 text-xs text-muted-foreground">
            Percentual do valor distribuído já encaminhado ao SOF.
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
